import React,{ useEffect } from 'react';
import $ from 'jquery';
// import drilldown from 'jquery-drilldown'
import Icons from "../../../Components/Icons/Icons";
import DropDownSearch from '../../../Components/DropDownSearch';
import Wrp from '../../../hoc/Wrp/Wrp';

const BasicDetails = (props) => {
  let isValidRules = false;
  if(props.rules) {
    props.rules.map((item) => {
      if(item.table_descriptor_id && item.table_descriptor_id!=='') {
        isValidRules = true;
      }
    })
  }
  const {pdfdata} = props;
	return (
    <div className="col-3">
      <div className="card no-box-shadow mb-0">
        <div className="card-header p-2">
          <div className="card-title"> Basic Info </div>
        </div>
        <div className="card-body pb-0">
          <div className="row">
            <div className="col-12">
              <div className={pdfdata.designName_error === '' ? "form-group" : "form-group has-error"}>
                <label>
                  PDF Name
                </label>
                <input type="text" name="designName" className="form-control mandatory" onChange={e=>props.onChangeHandler(e)} value={props.pdfdata.designName}/>
                {pdfdata.designName_error !== '' ?
                <label className="error m-0">{pdfdata.designName_error}</label>
                : null}
              </div>
            </div>

            <div className="col-12">
              <div className="form-group">
                <label>
                  Description
                </label>
                  <textarea className="form-control" name="description" onChange={e=> props.onChangeHandler(e)} value={props.pdfdata.description}></textarea>
              
              </div>
            </div>

            <div className="col-12">
              <div className="form-group">
                <label>
                  Format
                </label>
                <DropDownSearch
                  options={props.pdfdata.formatOptions}
                  values={props.pdfdata.format}
                  changeHandler={e=>props.onChangeHandler(e,"format")}
                />
              </div>
            </div>
            { props.pdfdata.format === 'Custom' ?
            <Wrp>
            <div className="col-12">
              <div className="form-group">
                <label>
                  Width
                </label>
                <div className="input-group">
                  <input type="number" name="width" className="form-control" onChange={e=>props.onChangeHandler(e)} value={props.pdfdata.width}/>
                  <div className="input-group-append">
                    <a className="input-group-text">mm</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="form-group">
                <label>
                  Height
                </label>
                <div className="input-group">
                  <input type="number" name="height" className="form-control" onChange={e=>props.onChangeHandler(e)} value={props.pdfdata.height}/>
                  <div className="input-group-append">
                    <a className="input-group-text">mm</a>
                  </div>
                </div>
              </div>
            </div>
            </Wrp>
            : null}
            <div className="col-12">
              <div className="form-group row">
                <label className="col-4">
                  Is Active
                </label>

                <div className="col-8">
                  <div className="material-switch p-2">
                      <input 
                        onChange={e=>props.onChangeHandler(e)} 
                        id="isActive" 
                        name="isActive" 
                        type="checkbox" 
                        checked={(props.pdfdata.isActive === 'true' || props.pdfdata.isActive === true) ? true : false}
                      />
                      <label htmlFor="isActive" className="secondary_bg"></label>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="form-group row">
                <label className="col-4">
                  Is Default
                </label>

                <div className="col-8">
                  <div className="material-switch p-2">
                      <input 
                        onChange={e=>props.onChangeHandler(e)} 
                        id="isDefault" 
                        name="isDefault" 
                        type="checkbox" 
                        checked={(props.pdfdata.isDefault === 'true' || props.pdfdata.isDefault === true) ? true : false}
                      />
                      <label htmlFor="isDefault" className="secondary_bg"></label>
                  </div>
                </div>
              </div>
            </div>
            

          </div>
        </div>
           

         <div className="card-header p-2 position-relative">
          <div className="card-title"> Template Filter </div>
          <h6 className="icon-right cursor-pointer" onClick={props.rulesToggleHandler}> 
          {
            isValidRules === true ?
            <Wrp><Icons iconType='Edit' /> <span className="text-small text-info"> Edit </span></Wrp>
            :
            <Wrp><i className="fas fa-plus fa-lg primary_color"></i> <span className="text-small text-info"> Add New </span></Wrp>
          }
          </h6>
        </div>

        <div className="card-body">
                    
          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center">
                <div className="">
                {
                  props.rules ?
                    props.rules.map((ruleItem, ruleInd) => {
                      return (
                        <label key={ruleInd} className="text-medium mb-0">
                        {
                          ruleInd !== 0 ?
                            <div className="badge badge-warning p-1 mr-1"> {ruleItem.logical_operator}  </div> 
                          : null
                        }
                         {ruleItem.fieldName} <code> {ruleItem.comparator} </code> 
                        {
                          Array.isArray(ruleItem.values) ? 
                            ruleItem.values.length > 0 ? ruleItem.values[0].label ? ruleItem.values[0].label : ruleItem.values[0].value : ''
                          : ruleItem.values
                        }
                        
                        </label>
                      )
                    })
                  : null
                }

                </div>
                {/*
                  isValidRules === true ?
                    <div className="cdesdesdd"> 
                      <a onClick={props.rulesToggleHandler} className=""> 
                        <Icons iconType='Edit' />
                      </a>
                    </div>
                  : null
                */}
              </div>
            </div>

          </div>

        </div>


      </div>

    

    </div>
	);
}

export default BasicDetails;